import React, { useState } from 'react';
import './FileControls.css';
import TutorialComponent from '../common/TutorialComponent';
import FeedbackComponent from '../common/FeedbackComponent';
import PreferencesModal from '../common/PreferencesModal'; // Import the PreferencesModal

const FileControls = ({ getData, onImportJSON }) => {
  const [isPreferencesOpen, setPreferencesOpen] = useState(false);

  const handleSave = () => {
    const dataToSave = getData();

    if (dataToSave) {
      const dataStr = JSON.stringify(dataToSave, null, 2);
      const blob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'performanceData.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };

  const handleImportJSON = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const importedData = JSON.parse(e.target.result);
          onImportJSON(importedData);
        } catch (error) {
          console.error("Invalid JSON file format", error);
          alert("Failed to import JSON. Please check the file format.");
        }
      };
      reader.readAsText(file);
    }
  };

  return (
    <div className="file-controls-container">
      <button onClick={handleSave} className="file-controls-button">
        Save
      </button>

      <label className="file-controls-button">
        Import
        <input
          type="file"
          accept=".json"
          onChange={handleImportJSON}
          style={{ display: 'none' }}
        />
      </label>

      {/* Preferences button */}
      <button onClick={() => setPreferencesOpen(true)} className="file-controls-button">
        Preferences
      </button>

      {isPreferencesOpen && (
        <PreferencesModal onClose={() => setPreferencesOpen(false)} />
      )}

      <TutorialComponent />
      <FeedbackComponent />
    </div>
  );
};

export default FileControls;
